<template>
  <div class="reward-list">
    <div class="reward-list__toolbar">
      <a-input-search
        v-model="Search"
        placeholder="Tìm theo họ tên hoặc 4 số cuối SĐT..."
        allow-clear
        style="width: 320px"
        @search="HandleSearch"
        @pressEnter="HandleSearch"
      />

      <a-button type="primary" @click="HandleSearch">
        <a-icon type="search" />
        Tìm
      </a-button>
    </div>

    <a-table
      rowKey="_id"
      size="small"
      bordered
      :columns="Columns"
      :data-source="Rows"
      :loading="Loading"
      :pagination="false"
    >
      <span slot="CashoutType" slot-scope="Value">
        <a-tag :color="Value ? 'green' : 'blue'">
          {{ Value ? "Tiền mặt" : "Voucher" }}
        </a-tag>
      </span>
    </a-table>

    <div v-if="Total > 0" class="reward-list__pagination">
      <a-pagination
        :current="Page"
        :page-size="PageSize"
        :total="Total"
        :show-size-changer="true"
        :show-quick-jumper="true"
        :page-size-options="['10', '20', '50']"
        :show-total="(total) => 'Tổng ' + total + ' người trúng thưởng'"
        @change="HandlePageChange"
        @showSizeChange="HandlePageSizeChange"
      />
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "RewardList",

  data() {
    return {
      Loading: false,

      Search: "",

      Rows: [],

      Page: 1,
      PageSize: 20,
      Total: 0,

      Columns: [
        {
          title: "Thời gian nhắn",
          dataIndex: "Created_At",
          key: "Created_At",

          customRender: (Value) => {
            return this.FormatDateTime(Value);
          },
        },

        {
          title: "Họ và tên",
          dataIndex: "Full_Name",
          key: "Full_Name",
        },

        {
          title: "Số điện thoại",
          dataIndex: "User_ID",
          key: "User_ID",
        },

        {
          title: "Ngày trả thưởng",
          dataIndex: "Distributed_Time",
          key: "Distributed_Time",

          customRender: (Value) => {
            return this.FormatDateTime(Value);
          },
        },
        {
          title: "Hình thức",
          dataIndex: "IsCashout",
          key: "IsCashout",
          scopedSlots: {
            customRender: "CashoutType",
          },
        },
      ],
    };
  },

  created() {
    this.LoadData();
  },

  methods: {
    async LoadData() {
      if (this.Loading) {
        return;
      }

      this.Loading = true;

      try {
        const Response = await axios.post(
          this.$PRJ_DOMAIN+"/getSecondPrizeWinners",
          {
            Page: this.Page,

            PageSize: this.PageSize,

            Search: String(this.Search || "").trim(),
          },
        );

        const Result = Response && Response.data ? Response.data : {};

        if (Result.State !== 1) {
          this.Rows = [];
          this.Total = 0;

          return;
        }

        const Data = Result.Data || {};

        this.Rows = Data.Items || Data.Rows || [];

        this.Total = Number(Data.Total || 0);

        this.Page = Number(Data.Page || this.Page);

        this.PageSize = Number(Data.PageSize || this.PageSize);
      } catch (Error) {
        console.log("RewardList-LoadData-Error:", Error);

        this.Rows = [];
        this.Total = 0;
      } finally {
        this.Loading = false;
      }
    },

    HandleSearch() {
      this.Page = 1;

      this.LoadData();
    },

    HandlePageChange(Page, PageSize) {
      this.Page = Page;

      if (PageSize) {
        this.PageSize = PageSize;
      }

      this.LoadData();
    },

    HandlePageSizeChange(Current, PageSize) {
      this.Page = 1;
      this.PageSize = PageSize;

      this.LoadData();
    },

    FormatDateTime(Value) {
      if (!Value) {
        return "";
      }

      const DateValue = new Date(Value);

      if (Number.isNaN(DateValue.getTime())) {
        return "";
      }

      const Pad = (Value) => String(Value).padStart(2, "0");

      return (
        Pad(DateValue.getDate()) +
        "/" +
        Pad(DateValue.getMonth() + 1) +
        "/" +
        DateValue.getFullYear() +
        " " +
        Pad(DateValue.getHours()) +
        ":" +
        Pad(DateValue.getMinutes())
      );
    },
  },
};
</script>

<style scoped>
.reward-list {
  width: 100%;
}

.reward-list__toolbar {
  display: flex;
  gap: 8px;
  margin-bottom: 12px;
}

.reward-list__toolbar .ant-input {
  flex: 1;
}

.reward-list__pagination {
  display: flex;
  justify-content: flex-end;
  margin-top: 14px;
}

@media (max-width: 576px) {
  .reward-list__toolbar {
    justify-content: stretch;
  }

  .reward-list__toolbar .ant-input-search {
    width: 100% !important;
  }

  .reward-list__pagination {
    justify-content: center;
    overflow-x: auto;
  }
}
</style>
